import { Component, OnInit } from '@angular/core';
import {VnaPortalService} from '../../services/vna-portal.service';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';
import {AuthService} from '../../../../../core/service/auth.service';

import * as _ from 'underscore';
import {ModalService} from 'ngx-dynamic-modal';
import {TestPortalServiceComponent} from '../test-portal-service/test-portal-service.component';
import {Router} from '@angular/router';
import {ServiceToPortalComponent} from '../../modals/service-to-portal/service-to-portal.component';

@Component({
  selector: 'app-portal-services',
  templateUrl: './portal-services.component.html',
  styleUrls: ['./portal-services.component.scss']
})
export class PortalServicesComponent implements OnInit {

    lastPortalSelected: number;
    portalServices: Array<Object> = [];
    enabled: boolean = false;

    constructor(
        private portalHandler: VnaPortalService,
        private messaging: MessagingService,
        private auth: AuthService,
        private modalHandler: ModalService,
        private router: Router
    ) {

    }

    ngOnInit() {
        this.lastPortalSelected = this.auth.getPkPortal();
        this.loadPortalServices();
        this.messaging.message.subscribe(
            (value) => {
                if(value.hasOwnProperty('pkPortal') && value.pkPortal !== this.lastPortalSelected){
                    this.loadPortalServices();
                    this.lastPortalSelected = value.pkPortal;
                }
            }
        )
    };

    modalCallback(res: any): void {
    }

    modalNewService(): void {
        this.modalHandler.addDynamicComponent(ServiceToPortalComponent, {}, (res) => {
            this.modalNewServiceCallback(res)
        })
    }

    modalNewServiceCallback(res: any): void {
        this.loadPortalServices();
    }

    testService(row: Object): void {
        this.modalHandler.addDynamicComponent(TestPortalServiceComponent, row, (res) => {
            this.modalCallback(res)
        })
    }

    isOverrided(portalService: Object): boolean {
        return (_.size(portalService['auth']) + _.size(portalService['config']) > 0);
    }

    editPortalService(row: Object): void {
        this.router.navigateByUrl('phone/config/portal/' + row['portal_pk'] + '/service/' + row['service_pk']);
    }

    removePortalService(row: Object): void {
        this.enabled = true;
        this
            .portalHandler
            .removeServiceFromPortal(row['portal_pk'], row['service_pk'])
            .subscribe(
                (r) => {
                    const idx = this.portalServices.findIndex((o) => { return row['portal_pk'] == o['portal_pk'] && row['service_pk'] == o['service_pk']});
                    if(idx >= 0){
                        this.portalServices.splice(idx, 1);
                    }

                    this.enabled = false;
                }
            )
    }

    private loadPortalServices(): void {
        this.enabled = true;
        this.portalHandler.findPortalServices(this.auth.getPkPortal()).subscribe(
            (result) => {
                this.portalServices = result;

                this.enabled = false;
            }
        )
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_portal/components/portal-services/portal-services.component.ts